var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979998",
    fillRule: "evenodd",
    d: "M8.833 1.075a7 7 0 0 0-.604-.025c-3.979 0-7.186 3.271-7.186 7.283s3.207 7.283 7.186 7.283a7.1 7.1 0 0 0 4.208-1.377l-.833-1.25a5.6 5.6 0 0 1-3.375 1.127c-3.13 0-5.686-2.578-5.686-5.783 0-3.204 2.556-5.783 5.686-5.783q.307 0 .604.032z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#979998",
    strokeDasharray: "1.33 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.23 14.867c3.555 0 6.436-2.925 6.436-6.534S11.785 1.8 8.23 1.8 1.793 4.725 1.793 8.333s2.882 6.534 6.437 6.534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#979998",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.23 8.333V6M8.23 8.333l2.873 2.917"
  })));
};
export default SvgPending;